import React from 'react';
import './DankNav.css';

const DankNav = () => (
<nav className="navbar navbar-expand-lg navbar-dark bg-dark">
  <div className="container">
    <a className="navbar-brand" href="#">D&amp;D Helper</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link" aria-current="page" href="/">Encounter Calculator</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/weather">Weather Randomizer</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
);

DankNav.propTypes = {};

DankNav.defaultProps = {};

export default DankNav;
